import React from "react";
import s from "../Calendar.css";
import CalendarView from "../calendar-view/CalendarView";
import { FormattedMessage } from "react-intl";
import messages from "../../../locale/messages";

class CalendarBody extends React.Component {
  render() {
    const { loading, listings, viewMode, canScrollLeft, dates } = this.props;

    if (loading) {
      return (
        <div className={`text-center ${s.p3}`}>
          <FormattedMessage {...messages.loadingLabel} />
        </div>
      );
    }

    return (
      <CalendarView
        listings={listings}
        viewMode={viewMode}
        canScrollLeft={canScrollLeft}
        dates={dates}
      />
    );
  }
}

export default CalendarBody;
